import { PublicServiceConfig } from '@/lib/models/policy-model/public-services';

export type ServiceAction = 'default' | 'block' | 'monitor' | 'allow' | undefined;

/**
 * Determines the current action for a service based on its entry in serviceAccess
 */
export const getServiceAction = (serviceId: string, config: PublicServiceConfig): ServiceAction => {
  const serviceAccess = config.serviceAccess || [];
  const entity = serviceAccess.find((entry) => entry.serviceId === serviceId);

  if (!entity) {
    return 'default';
  }

  switch (entity.action) {
    case 'blocked':
      return 'block';
    case 'monitored':
      return 'monitor';
    case 'protected':
      return 'allow';
    default:
      return 'default';
  }
};

/**
 * Updates the config by applying the specified action to a service
 */
export const applyServiceAction = (
  config: PublicServiceConfig,
  serviceId: string,
  action: ServiceAction
): PublicServiceConfig => {
  const serviceAccess = config.serviceAccess || [];
  const otherEntries = serviceAccess.filter((entry) => entry.serviceId !== serviceId);

  switch (action) {
    case 'block':
      return new PublicServiceConfig({
        ...config,
        serviceAccess: [...otherEntries, { serviceId, action: 'blocked' }],
      });
    case 'monitor':
      return new PublicServiceConfig({
        ...config,
        serviceAccess: [...otherEntries, { serviceId, action: 'monitored' }],
      });
    case 'allow':
      return new PublicServiceConfig({
        ...config,
        serviceAccess: [...otherEntries, { serviceId, action: 'protected' }],
      });
    case 'default':
      return new PublicServiceConfig({
        ...config,
        serviceAccess: otherEntries,
      });
  }

  return config;
};
